<!--请求重传历史未接收上报数据接口-->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "startTime":"20180703000000",
                "endTime":"20180703235959"
           },
            responseCode: {"data": {

                },"message":"业务成功","resultCode":0,"status":1},
            infoData: {
                explain: "智慧停车开放平台主动上报类接口已实现上报数据未成功接收的重传机制。但因网络不通、授权商接收端始终掉线等不可抗拒原因，上报数据按照策略超过一定时间后，将不再重发。授权商调用此接口后，会触发系统再次上报过期数据。过期数据包括：进场上报,出场上报,月卡开通续费上报,遥控开闸上报,校正车牌上报,临停交费上报,储值卡扣费流水上报,车主信息上报,车辆信息上报,设备状态信息上报,交接班信息上报,车位信息上报,预进场上报,预出场上报,车场心跳,黑名单上报等信息。",
                t_url: this.commonUrls.test+"requestFailDataResend",
                p_url: this.commonUrls.prod+"requestFailDataResend",
                precondition: "上报失败数据产生超过15日后，平台将永久删除相关数据。调用此接口获取此类数据，将提示“数据超过15日，不可获取”。",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '时间段开始时间, yyyyMMddHHmmss（时间段间隔不能超过1天，建议从当天00:00:00到23:59:59进行请求）' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '时间段结束时间, yyyyMMddHHmmss' },
                        { info1: 'dataType', info2: '否', info3: 'Integer', info4: '数据类型 0-reportCarIn(进场上报)、1-reportCarOut出场上报、、2-reportParkBill（账单上报）、3-reportMonthCar（月卡开通续费上报）、4reportAbnormalCar（遥控开闸上报）、5-reportModifyCar（校正车牌上报）、6-reportParkingFee（临停交费上报）、7-reportCarPicture（图片信息上报）、8-reportTicketUseRecord（储值卡扣费流水上报）、9-reportCarOwner（车主信息上报）、10-reportCar（车辆信息上报）、11-reportEquipmentStatus（设备状态信息上报）、12-reportShift（交接班信息上报）、13-reportCarport（车位信息上报）、14-reportPreCarIn（预进场上报）、15-reportPreCarOut（预出场上报）、21-reportBlacklistRecord（黑名单上报）、25-reportAccountLogin（同步账户登陆）、26-alert（告警）、27-reportDailyParkFee（同步日报表数据）、28-reportAuthUserCarInfo（智慧停车用户绑定车牌及变更上报）、29-reportAuthUserInfo（智慧停车注册用户信息上报）、30-reportAuthUserAuthPic（智慧停车用户认证图片上报）、、33-notifyPayInfoWithoutPayOrder（第三方调用ydtw扫码支付接口通知支付账单信息）、34-reportQrCode（扫码机上报扫码信息）、35-reportChannelBindForScan（扫码机上报通道绑定关系信息）' },
                        { info1: 'dataParam1', info2: '否', info3: 'String', info4: '数据筛选字段1，该字段选填。一般为停车场编码，可针对指定车场做数据重传' },
                        { info1: 'dataParam2', info2: '否', info3: 'String', info4: '数据筛选字段2' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                    },
                ]
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/requestFailDataResend.vue